<template>
    <div class="loader" :class="classes">
        <div class="loader-gif">
        </div>
    </div>
</template>
<script setup>
import { defineProps, toRefs } from 'vue';

const props = defineProps({
    classes: String,
});
let { classes } = toRefs(props);

</script>


<style lang="scss">
.loader-index-9999 {
    &::before {
        height: 100vh !important;
        z-index: 9999 !important;

    }
}

.loader {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 8;

    &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100vh;
        background: #f0f0f0;
        opacity: 0.6;
        z-index: 9;

    }
}

.loader-gif {
    background-image: url('@/assets/img/loading.svg');
    background-repeat: no-repeat;
    background-size: contain;
    width: 65px;
    height: 65px;
    z-index: 999;

}



</style>